import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { TFAService } from 'mbs-ui-shared@services/tfa.service';
import { catchError, of } from 'rxjs';

interface TFAState {
  status: boolean;
  loaded: boolean;
  loading: boolean;
}

const initialState: TFAState = {
  status: true,
  loaded: false,
  loading: false
};

export const TFAStore = signalStore(
  { providedIn: 'root' },
  withDevtools('TFAStore'),
  withState<TFAState>(initialState),
  withMethods((store, tfaService = inject(TFAService)) => ({
    loadTFAStatus(force = false): void {
      if (store.loaded() && !force) return;
      patchState(store, { loading: true });
      tfaService
        .getTFAEnabledStatus()
        .pipe(catchError(() => of({ enabled: false })))
        .subscribe(({ enabled }) => {
          patchState(store, { status: enabled, loaded: true, loading: false });
        });
    }
  }))
);

export type TFAStoreType = InstanceType<typeof TFAStore>;
